import request from '@/utils/request';
// 编辑设备
export const editDevice = (data: any) =>
  request({
    url: 'Device/device',
    method: 'PUT',
    data
  });
// 批量删除设备
// export const delAllDevice = (data: any) =>
//   request({
//     url: 'Device/batchDevice',
//     method: 'DELETE',
//     data
//   });
// 删除设备
export const delDevice = (data: any) =>
  request({
    url: 'Device/device',
    method: 'DELETE',
    data
  });
// 添加设备
export const addDevice = (data: any) =>
  request({
    url: 'Device/Device',
    method: 'POST',
    data
  });
  // 获取设备添加限制
export const deviceLimit = (params: any) =>
  request({
    url: 'Device/deviceLimit',
    method: 'get',
    params
  });
// 获取服务方授权我的设备列表
export const getSerAuthMeList = (params: any) =>
  request({
    url: 'Device/serAuthMeList',
    method: 'get',
    params
  });
// 获取服务方授权我的设备详情
export const getDeviceAuthDetail = (params: any) =>
  request({
    url: 'Device/auth',
    method: 'get',
    params
  });
  // 设备履历
export const getDeviceOrderHistory = (params: any) =>
  request({
    url: 'Device/orderHistory',
    method: 'get',
    params
  });
  // 导入设备
export const importDevice = (data:any) =>
  request({
    url: 'Device/import',
    method: 'POST',
    data
  });

// 导出设备
export const batchQrCode = (params: any) =>
  request({
    url: 'Device/batchQrCode',
    method: 'get',
    params,
    responseType: 'blob'
  });

//批量修改设置 目前支持报修部门
export const batchModifyDevice = (data:any) =>
request({
  url: 'Device/batchModifyDevice',
  method: 'POST',
  data
});
  
// 导入品牌
export const importBrand = (data:any) =>
  request({
    url: 'Device/importBrand',
    method: 'POST',
    data
  });
  // 获取品牌
export const productList = (params: any) =>
  request({
    url: 'Device/productList',
    method: 'get',
    params
  });
// 搜索品牌
export const productNewList = (params: any) =>
  request({
    url: 'Device/productNewList',
    method: 'get',
    params
  });

export const getDeviceList = (params: any) =>
  request({
    url: 'Device/deviceList',
    method: 'get',
    params
  });
  // 报修弹窗选设备
export const getDevice = (params: any) =>
  request({
    url: 'Device/Device',
    method: 'get',
    params
  });
export const getBrandList = (params: any) =>
  request({
    url: 'Device/brandList',
    method: 'get',
    params
  });

export const getDeviceAuthMe = (params: any) =>
  request({
    url: 'Device/cusAuthMe',
    method: 'get',
    params
  });

export const addDeviceBrand = (data: any) =>
  request({
    url: 'Device/Brand',
    method: 'post',
    data
  });
export const editDeviceBrand = (data: any) =>
  request({
    url: 'Device/brand',
    method: 'put',
    data
  });
export const deleteDeviceBrand = (data: any) =>
  request({
    url: 'Device/brand',
    method: 'delete',
    data
  });
export const addDeviceProduct = (data: any) =>
  request({
    url: 'Device/Product',
    method: 'post',
    data
  });
export const editDeviceProduct = (data: any) =>
  request({
    url: 'Device/Product',
    method: 'put',
    data
  });
export const deleteDeviceProduct = (data: any) =>
  request({
    url: 'Device/Product',
    method: 'delete',
    data
  });
export const addDeviceModel = (data: any) =>
  request({
    url: 'Device/Model',
    method: 'post',
    data
  });
export const editDeviceModel = (data: any) =>
  request({
    url: 'Device/Model',
    method: 'put',
    data
  });
export const deleteDeviceModel = (data: any) =>
  request({
    url: 'Device/Model',
    method: 'delete',
    data
  });
export const batchDeleteBrand = (data: any) =>
  request({
    url: 'Device/batchDeleteBrand',
    method: 'delete',
    data
  });
export const getAuthSer = (params: any) =>
  request({
    url: 'Device/authSer',
    method: 'get',
    params
  });
export const setAuthSerDetail = (data: any) =>
  request({
    url: 'Device/authSer',
    method: 'put',
    data
  });

// export const deleteAuthSerDetail = (data: any) =>
//   request({
//     url: 'Device/authSer',
//     method: 'delete',
//     data
//   });

export const getAuthCus = (params: any) =>
  request({
    url: 'Device/authCus',
    method: 'get',
    params
  });
export const setAuthCusDetail = (data: any) =>
  request({
    url: 'Device/authCus',
    method: 'put',
    data
  });

export const deleteAuthCusDetail = (data: any) =>
  request({
    url: 'Device/authCus',
    method: 'delete',
    data
  });

export const getParts = (params: any) =>
  request({
    url: 'Device/Parts',
    method: 'get',
    params
  });

export const getPartsAttribute = (params: any) =>
  request({
    url: 'Device/PartsAttribute',
    method: 'get',
    params
  });
  // 授权设备
export const impowerDevice = (data: any) =>
  request({
    url: 'Device/impower',
    method: 'post',
    data
  });
